import {Typography} from '@mui/material';
import {t} from 'i18next';
import React from 'react';
import {AurLightTooltip} from '../../common/aur-light-tooltip/aur-light-tooltip';

interface Props {
  createdBy?: string; // user createdBy Name
  updatedBy?: string; // user updatedBy Name
  createdDate?: string; // user createdOn Date
  updatedDate?: string; // user updatedOn Date
}

const AurUserCreatorDetails: React.FC<Props> = (props: Props) => {
  const {createdBy, updatedBy, createdDate, updatedDate} = props;
  return (
    <div className="aur-user-creator-details-container">
      <Typography className={`typo-text label1_size mist-color-900`}>
        {t('common.createdBy', {createdBy: createdBy})}
        <AurLightTooltip title={t('common.yearMonthDate')}>
          <span className="text-padding">{`${createdDate}`}</span>
        </AurLightTooltip>
      </Typography>
      {updatedBy && (
        <Typography className={`typo-text label1_size mist-color-900`}>
          {t('common.lastEditedBy', {updatedBy: updatedBy})}
          <AurLightTooltip title={t('common.yearMonthDate')}>
            <span className="text-padding">{`${updatedDate}`}</span>
          </AurLightTooltip>
        </Typography>
      )}
    </div>
  );
};

export default AurUserCreatorDetails;
